// import React, { useState, useEffect } from "react";
// import { Link, useHistory } from "react-router-dom";
// import Popup from "reactjs-popup";
// import "../../App.css";
// import "./Login.css";
// import axios from "axios";
// import Cookies from "js-cookie";
// import { sha256 } from "js-sha256";
// import eyeShowPassword from "../../images/eyeShowPassword.png";
// import eyeHidePassword from "../../images/eyeHidePassword.png";

// const LogIn = () => {
//   let history = useHistory();

//   const [phone, setPhone] = useState("");
//   const [password, setPassword] = useState("");
//   const [isErrorMessageDisplayed, setIsErrorMessageDisplayed] = useState(false);
//   const [isResetErrorDisplayed, setIsResetErrorDisplayed] = useState(false);
//   const [errorMessage, setErrorMessage] = useState("");
//   const [errorMessageInResetPassword, setErrorMessageInResetPassword] =
//     useState("");
//   const [passwordInputType, setPasswordInputType] = useState("password");
//   const [isResetPasswordDisplayed, setIsResetPasswordDisplayed] =
//     useState(false);
//   const [email, setEmail] = useState("");
//   const [isPasswordResetSuccessfully, setIsPasswordResetSuccessfully] =
//     useState(null);

//   const israelPhoneValidatorRegex =
//     /^\+?(972|0)(\-)?0?(([23489]{1}\d{7})|[5]{1}\d{8})$/i;

//   const config = {
//     headers: {
//       "Content-Type": "application/json",
//     },
//     withCredentials: true,
//   };

//   useEffect(() => {
//     if (Cookies.get("userId")) {
//       history.push("/questionnaires");
//     }
//   }, []);

//   var userM = 0; // i need it in global place, it calles userM - m for michal - my develop

//   const alertUser = (message) => {
//     setIsErrorMessageDisplayed(true);
//     setErrorMessage(message);
//   };

//   const phoneValidator = (phoneNumber) => {
//     return israelPhoneValidatorRegex.exec(phoneNumber) !== null;
//   };

//   const checkPassword = (password) => {
//     if (password) {
//       return true;
//     } else {
//       return false;
//     }
//   };

//   const logInClicked = async () => {
//     // console.log(sha256(password));
//     if (phoneValidator(phone)) {
//       if (checkPassword(password)) {
//         // console.log("Starting log in process");
//         setIsErrorMessageDisplayed(false);
//         try {
//           const response = await axios.post(
//             process.env.REACT_APP_LOCALHOST_ADDRESS + "/PlogIn",
//             {
//               phone: phone,
//               password: sha256(password),
//             },
//             config,
//           );

//           if (Cookies.get("userId") > "0" && response.status == 200) {
//             history.push("/questionnaires");
//           } else {
//             alertUser(
//               "המשתמש לא קיים או שיש טעות בסיסמה, על מנת ליצור משתמש, אנא הירשם." +
//                 "   יש  מצב אולי שבחרת סיסמה עם אות גדולה והקשת אות קטנה? או להיפך?",
//             );
//           }
//         } catch (error) {
//           if (error.message.includes(500)) {
//             alertUser("יש שגיאה בשרת, אנא נסה שנית עוד מעט");
//           } else {
//             alertUser(
//               "המשתמש לא קיים או שיש טעות בסיסמה, על מנת ליצור משתמש, אנא הירשם." +
//                 "   יש  מצב אולי שבחרת סיסמה עם אות גדולה והקשת אות קטנה? או להיפך?",
//             );
//           }
//         }
//       } else {
//         alertUser("על מנת להתחבר יש להשתמש בסיסמה");
//       }
//     } else {
//       alertUser("מספר הטלפון לא תקין, יש להכניס מספר טלפון ישראלי");
//     }
//   };

//   const signUpClicked = () => {
//     history.push("/signup");
//   };

//   const resetUserPassword = async () => {
//     try {
//       const response = await axios.post(
//         process.env.REACT_APP_LOCALHOST_ADDRESS + "/reset/password",
//         { email },
//         config,
//       );

//       // console.log(response.status);
//       if (response.status === 200) {
//         setIsResetErrorDisplayed(false);
//         setIsPasswordResetSuccessfully(true);
//         setInterval(() => {
//           setIsResetPasswordDisplayed(false);
//           setIsPasswordResetSuccessfully(null);
//         }, 5000);
//       }
//     } catch (error) {
//       if (error.response.status === 404) {
//         setIsResetErrorDisplayed(true);
//         setErrorMessageInResetPassword(
//           "כתובת האימל לא קיימת במערכת, נסה שנית או צור קשר",
//         );
//       }
//     }
//   };

//   const resetPasswordClicked = () => {
//     // console.log("starting resetting password");
//     setIsResetPasswordDisplayed(true);
//   };

//   return (
//     <div className="login-form">
//       <div className="hp-logo" />
//       <form className="login-form1">
//         <div className="section-title" style={{ margin: "0 auto" }}>
//           כניסה
//         </div>
//         <input
//           type="number"
//           id="tel"
//           placeholder="טלפון"
//           value={phone}
//           onChange={(e) => setPhone(e.target.value)}
//         ></input>
//         <div className="password-input-container">
//           <span
//             className="password-input-span"
//             onClick={() => {
//               if (passwordInputType === "password") {
//                 setPasswordInputType("text");
//               } else {
//                 setPasswordInputType("password");
//               }
//             }}
//           >
//             {passwordInputType === "text" ? (
//               <img className="eye-image-in-span" src={eyeHidePassword} />
//             ) : (
//               <img className="eye-image-in-span" src={eyeShowPassword} />
//             )}

//             {/* style ={{backgroundImage: `url(${eyeShowPassword})`}} */}
//           </span>
//           <input
//             type={passwordInputType}
//             id="pwd"
//             placeholder="סיסמה"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//           />{" "}
//         </div>
//         {/* <label className="password">{label}
//         <input type={this.state.type} className="password__input"/>

//       </label> */}
//         <span
//           className="reset-password-button"
//           style={{ padding: "30px 0px 20px 0px" }}
//           onClick={resetPasswordClicked}
//         >
//           שכחתי סיסמה
//         </span>
//         <span
//           div
//           className="section-title"
//           style={{ fontSize: "14px", margin: "0 10px 0 0" }}
//         >
//           לידיעתך, באתר זה נעשה שימוש בקבצי Cookies. המשך גלישתך באתר מהווה
//           הסכמה לשימוש זה .
//         </span>{" "}
//         {isErrorMessageDisplayed && (
//           <div className="error-message">
//             <h5> {errorMessage} </h5>{" "}
//           </div>
//         )}{" "}
//         <div className="button-text-center" onClick={logInClicked}>
//           כניסה
//         </div>
//         <Link
//           to="/questionnaires"
//           style={{
//             textDecoration: "none",
//           }}
//         ></Link>{" "}
//         {/* <Link to="/signup" style={{ textDecoration: "none" }}> */}{" "}
//         <Link to="/" style={{ textDecoration: "none" }}>
//           <div className="button whiteBackNBorder" id="backBtn">
//             {" "}
//             חזרה
//             <b>→</b>
//           </div>
//         </Link>
//         <div className="singup-line">
//           <div className="section-title" style={{ fontSize: "14px" }}>
//             {" "}
//             אין לך חשבון?{" "}
//           </div>
//           <div
//             className="signup-btn"
//             style={{ paddingTop: "4px" }}
//             onClick={signUpClicked}
//           >
//             {" "}
//             להרשמה{" "}
//           </div>{" "}
//         </div>
//         {/* </Link> */}
//         {/* { <div className='error'>{user.logInError}</div> } */}{" "}
//       </form>{" "}
//       <Popup
//         open={isResetPasswordDisplayed}
//         contentStyle={{ minWidth: "80%", borderRadius: "5px" }}
//         position="right center"
//         onClose={() => setIsResetPasswordDisplayed(false)}
//         closeOnDocumentClick
//         closeOnEscape
//       >
//         <div className="reset-password-container">
//           {isPasswordResetSuccessfully == true ? (
//             <h4>סיסמה חדשה נשלחה למייל שלך, יתכן לתיקיית הספאם</h4>
//           ) : (
//             <>
//               <div className="reset-password-title">איפוס סיסמה</div>
//               <div className="reset-password-body">
//                 סיסמה חדשה תשלח לך למייל, יתכן לתיקיית הספאם
//               </div>
//               <input
//                 className="reset-password-email-input"
//                 type="email"
//                 id="email"
//                 value={email}
//                 autocomplete="off"
//                 placeholder='דוא"ל'
//                 onChange={(e) => {
//                   setIsResetErrorDisplayed(false);
//                   setEmail(e.target.value);
//                 }}
//               ></input>
//               <div
//                 className="reset-password-popup-button"
//                 onClick={resetUserPassword}
//               >
//                 שלח לי סיסמה
//               </div>
//               {isResetErrorDisplayed ? (
//                 <h4>{errorMessageInResetPassword}</h4>
//               ) : null}
//             </>
//           )}
//         </div>
//       </Popup>
//     </div>
//   );
// };

// export default LogIn;

import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import "../../App.css";
import "./Login.css";
import axios from "axios";
import Cookies from "js-cookie";
import { sha256 } from "js-sha256";
import eyeShowPassword from "../../images/eyeShowPassword.png";
import eyeHidePassword from "../../images/eyeHidePassword.png";

const MIN_TIME_BETWEEN_OTP_RESENDS = 60 * 1000; // 1 minute
const MAX_OTP_SENDS_BEFORE_COOLDOWN = 3;

const LogIn = () => {
  const history = useHistory();

  const [loginMode, setLoginMode] = useState("password"); // password / emailCode
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [emailCode, setEmailCode] = useState("");
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [codeSentTimestamp, setCodeSentTimestamp] = useState(null);
  const [otpResendTimeLeft, setOtpResendTimeLeft] = useState(0);
  const [otpAmountSent, setOtpAmountSent] = useState(0);
  const [showDoubleistInfo, setShowDoubleistInfo] = useState(false);

  const [passwordInputType, setPasswordInputType] = useState("password");
  const [isErrorMessageDisplayed, setIsErrorMessageDisplayed] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const israelPhoneValidatorRegex =
    /^\+?(972|0)(\-)?0?(([23489]{1}\d{7})|[5]{1}\d{8})$/i;

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  };

  useEffect(() => {
    if (Cookies.get("userId")) {
      const userType = Cookies.get("userType");
      if (userType === "2") {
        history.push("/helperhome");
      } else {
        history.push("/questionnaires");
      }
    }
  }, [history]);

  const alertUser = (message) => {
    setIsErrorMessageDisplayed(true);
    setErrorMessage(message);
  };

  const clearError = () => {
    setIsErrorMessageDisplayed(false);
    setErrorMessage("");
  };

  const phoneValidator = (phoneNumber) => {
    return israelPhoneValidatorRegex.exec(phoneNumber) !== null;
  };

  const signUpClicked = () => {
    history.push("/signup");
  };

  const navigateAfterLogin = () => {
    console.log("navigate after login");
    const userType = Cookies.get("userType");

    if (userType === "2") {
      history.push("/helperhome");
    } else {
      history.push("/questionnaires");
    }
  };

  const logInClicked = async () => {
    clearError();

    if (!phoneValidator(phone)) {
      alertUser("מספר הטלפון לא תקין, יש להכניס מספר טלפון ישראלי");
      return;
    }

    if (!password) {
      alertUser("על מנת להתחבר יש להכניס סיסמה");
      return;
    }

    try {
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/PlogIn",
        {
          phone,
          password: sha256(password),
        },
        config,
      );

      if (Cookies.get("userId") > "0" && response.status === 200) {
        navigateAfterLogin();
      } else {
        alertUser("המשתמש לא קיים או שיש טעות בסיסמה");
      }
    } catch (error) {
      alertUser("לא הצלחנו להתחבר. נא לנסות שוב בעוד רגע");
    }
  };

  const sendCodeToEmail = async () => {
    clearError();

    if (!email) {
      alertUser("יש להכניס כתובת מייל");
      return;
    }

    const now = Date.now();
    if (
      codeSentTimestamp &&
      now - codeSentTimestamp < MIN_TIME_BETWEEN_OTP_RESENDS
    ) {
      // The user is not suppost to see this, as the UI should prevent it.
      alertUser("הקוד נשלח כבר לפני רגע. אנא המתן לפני שליחת קוד נוסף");
      return;
    }

    try {
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/otp/send",
        {
          email,
        },
        config,
      );

      if (response.status === 200) {
        setIsCodeSent(true);
        setOtpAmountSent((otpAmountSent) => otpAmountSent + 1);
        setCodeSentTimestamp(Date.now());
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        alertUser("המייל לא נמצא במערכת. נא לנסות מייל אחר או להירשם לאתר");
      } else if (error.response && error.response.status === 400) {
        alertUser("נשלחו יותר מדי קודים. נא לנסות שוב בעוד כמה דקות");
      } else {
        alertUser("לא הצלחנו לשלוח קוד למייל. נא לנסות שוב בעוד רגע");
      }
    }
  };

  const loginWithEmailCode = async () => {
    clearError();

    if (!emailCode) {
      alertUser("יש להכניס את הקוד שנשלח למייל");
      return;
    }

    try {
      const response = await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/otp/verify",
        {
          email,
          otp: emailCode,
        },
        config,
      );

      if (Cookies.get("userId") > "0" && response.status === 200) {
        navigateAfterLogin();
      } else {
        alertUser("הקוד שגוי או שפג תוקף");
      }
    } catch (error) {
      alertUser("הקוד שגוי או שפג תוקף");
    }
  };

  useEffect(() => {
    const updateFunction = () => {
      if (codeSentTimestamp) {
        const timeLeft = Math.max(
          0,
          MIN_TIME_BETWEEN_OTP_RESENDS - (Date.now() - codeSentTimestamp),
        );
        setOtpResendTimeLeft(timeLeft);
      }
    };
    const interval = setInterval(updateFunction, 1000);

    updateFunction();

    return () => clearInterval(interval);
  }, [codeSentTimestamp]);

  return (
    <div className="login-form">
      <div className="hp-logo" />

      <form className="login-form1">
        <br />
        <div className="doubleist-mini-box">
          <span className="doubleist-mini-title">דאבליסטים?</span>
          <span className="doubleist-mini-text">
            נכנסים כאן גם מלווים ושדכנים.
          </span>
          <span
            className="doubleist-mini-link"
            onClick={() => setShowDoubleistInfo(!showDoubleistInfo)}
          >
            מה זה?
          </span>

          {showDoubleistInfo && (
            <div className="doubleist-mini-more">
              דאבליסט הוא חבר/ה מלווה, בן משפחה או שדכן/ית שעוזר/ת למועמדים
              למצוא התאמות ולעקוב יחד אחרי ההצעות. לאחר הכניסה נזהה אותך ונעביר
              אותך למקום המתאים.
            </div>
          )}
        </div>

        <div className="login-tabs">
          <div
            className={`login-tab ${loginMode === "password" ? "active" : ""}`}
            onClick={() => {
              clearError();
              setLoginMode("password");
            }}
          >
            עם סיסמה
          </div>

          <div
            className={`login-tab ${loginMode === "emailCode" ? "active" : ""}`}
            onClick={() => {
              clearError();
              setLoginMode("emailCode");
            }}
          >
            קוד למייל
          </div>
        </div>

        {loginMode === "password" ? (
          <>
            <input
              type="number"
              id="tel"
              placeholder="טלפון"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />

            <div className="password-input-container">
              <span
                className="password-input-span"
                onClick={() =>
                  setPasswordInputType(
                    passwordInputType === "password" ? "text" : "password",
                  )
                }
              >
                {passwordInputType === "text" ? (
                  <img className="eye-image-in-span" src={eyeHidePassword} />
                ) : (
                  <img className="eye-image-in-span" src={eyeShowPassword} />
                )}
              </span>

              <input
                type={passwordInputType}
                id="pwd"
                placeholder="סיסמה"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <div className="button-text-center" onClick={logInClicked}>
              כניסה
            </div>
          </>
        ) : (
          <>
            <input
              type="email"
              placeholder='דוא"ל'
              value={email}
              autoComplete="off"
              onChange={(e) => setEmail(e.target.value)}
            />

            <div className="email-code-note">
              נשלח לך קוד חד פעמי למייל המעודכן במערכת.
              <br />
              הקוד תקף ל־10 דקות.
            </div>

            <div
              className="button whiteBackNBorder"
              onClick={sendCodeToEmail}
              style={{
                margin: "18px auto 16px",
                width: "70%",
                maxWidth: "300px",
                minHeight: "42px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                lineHeight: "1.2",
                padding: "0 18px",
                boxSizing: "border-box",
              }}
            >
              {isCodeSent ? "שלחו לי קוד נוסף" : "שלחו לי קוד למייל"}
            </div>

            <input
              type="number"
              placeholder="הקוד שקיבלת במייל"
              value={emailCode}
              onChange={(e) => setEmailCode(e.target.value)}
            />

            <div className="button-text-center" onClick={loginWithEmailCode}>
              כניסה עם הקוד
            </div>
            {otpAmountSent >= MAX_OTP_SENDS_BEFORE_COOLDOWN ? (
              <div className="login-switch-hint">
                שלחת מספר בקשות קוד בזמן קצר 😊 ניתן לבקש קוד נוסף בעוד 10 דקות.
                ולבינתיים מומלץ לבדוק בתיקיית הספאם/עדכונים
              </div>
            ) : otpResendTimeLeft > 0 ? (
              <div className="login-switch-hint">
                ניתן לשלוח קוד נוסף בעוד {Math.ceil(otpResendTimeLeft / 1000)}{" "}
                שניות
              </div>
            ) : (
              <div className="login-switch-hint" onClick={sendCodeToEmail}>
                לא קיבלת? שלחו לי שוב
              </div>
            )}
          </>
        )}

        {isErrorMessageDisplayed && (
          <div className="error-message">
            <h5>{errorMessage}</h5>
          </div>
        )}
        <br />
        <a
          className="login-whatsapp-help"
          href="https://wa.me/972549624084?text=שלום, אני לא מצליח/ה להיכנס לאתר דאבל"
          target="_blank"
          rel="noreferrer"
        >
          יש בעיה בכניסה? כתבו לנו בווטסאפ
        </a>

        <Link to="/" className="back-link-minimal">
          חזרה
        </Link>

        <div className="signup-line-clean">
          אין לך חשבון? <span onClick={signUpClicked}>להרשמה</span>
        </div>

        <div className="cookies-text small">
          האתר משתמש ב-Cookies. המשך גלישה מהווה הסכמה.
        </div>
      </form>
    </div>
  );
};

export default LogIn;
